'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _MarketingPresenter() {
  this.extends = [_AnalyticsData];
  this.presenter = window.marketingApiPresenter || new APIPresenter();
  window.marketingApiPresenter = this.presenter;
  this._initialized = false;

  this.init = function () {
    this._super();

    this.setupContentPageModel();
    if (location.pathname.indexOf('/products/') == 0) {
      this.loadCampaignData();
    }

    this.analytics = new Analytics();
    this.analytics.update(this.analyticsData, this);
  };

  this.initAllReady = function () {};

  // MKTG-375: page content is served from a local Contentful snapshot instead of
  // hitting cdn.contentful.com at runtime. The locale-space branch used to fetch
  // from a separate Contentful space whose access tokens have been invalid in
  // production (returning 401), so locale-variant pages silently got no data;
  // post-refactor they behave the same (match on the default snapshot or not at all).
  this.setupContentPageModel = function () {
    var pageName = $('[data-mogo-page]')[0].dataset.mogoPage;
    window.marketingApiPresenter.pageContentLoadedPromise = $.Deferred();

    // Invoke the same downstream callback on both success and failure so
    // pageContentLoadedPromise always resolves — otherwise a snapshot fetch
    // failure would hang any waiters on it. Matches the old Contentful
    // getResource behaviour, which called back with null data on HTTP failure.
    var handle = this._onLoadContentfulData.bind(this, pageName, this._onPageContentReady.bind(this));
    ContentSnapshots.findOne('page', function (item) {
      return item && item.name === pageName;
    }).done(handle).fail(function () {
      handle(null);
    });
  };

  this._onLoadContentfulData = function (pageName, onComplete, data) {
    if (data && _typeof(data.items) === 'object' && data.items.length) {
      if (!this.presenter.models.content) {
        this.presenter.createModel('content', { data: { pages: [] } });
      }
      var contentTree = this._buildContentTree(data.items[0]);
      this.presenter.setModelProperty('content.pages.' + pageName, contentTree);
    }
    if (onComplete) onComplete();
  };

  this._buildContentTree = function (contentfulNode) {
    var node = {};

    for (var childName in contentfulNode) {
      // exclude meta content from the model:
      if (contentfulNode.hasOwnProperty(childName) && childName !== '__meta') {
        var childNode = contentfulNode[childName];
        if (childNode instanceof Array && childNode.length) {
          for (var i = 0; i < childNode.length; i++) {
            var list = childNode[i];
            if (list.name || list.key) {
              node[list.name || list.key] = this._buildContentTree(list);
            }
          }
        } else {
          node[childName] = childNode;
        }
      }
    }
    return node;
  };

  this.loadCampaignData = function () {
    if (this.presenter.getModelProperty('campaigns')) {
      this.parseCampaignData();
    } else {
      $.ajax({
        url: campaignDataUrl,
        dataType: 'json',
        success: function (data) {
          this.presenter.campaigns = data;
          this.parseCampaignData();
        }.bind(this)
      });
    }
  };

  this.parseCampaignData = function () {
    var campaignId = getURLParameter('campaignid').trim();
    var campaignData = this.presenter.campaigns;
    if (campaignId && campaignData) {
      // look for matching campaign id in campaign data
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(campaignData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var product = _ref2[0];
          var productCampaigns = _ref2[1];

          var currentCampaign = productCampaigns.find(function (campaign) {
            return campaign.CampaignId == campaignId;
          });
          if (currentCampaign) {
            // find all instances of campaign nodes in page and replace content with data from campaign file
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = Object.entries(currentCampaign)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _ref3 = _step2.value;

                var _ref4 = _slicedToArray(_ref3, 2);

                var key = _ref4[0];
                var value = _ref4[1];

                var element = document.querySelector('[data-campaign=' + key + ']');
                if (element) {
                  // image nodes - change image src
                  if (element.nodeName == 'PICTURE') {
                    var _value$split = value.split('.'),
                        _value$split2 = _slicedToArray(_value$split, 2),
                        baseFilename = _value$split2[0],
                        filetype = _value$split2[1];

                    // remove all current child nodes


                    element.textContent = '';

                    // build source nodes for 3 resolutions
                    var resolutions = [{ minWidth: 1024, suffix: '-l-d' }, { minWidth: 641, suffix: '-t' }, { minWidth: 0, suffix: '-m' }];
                    for (var i = 0; i < resolutions.length; i++) {
                      var sourceEl = document.createElement('source');
                      if (resolutions[i].minWidth > 0) {
                        sourceEl.setAttribute('media', '(min-width: ' + resolutions[i].minWidth + 'px)');
                      }
                      var filenameFrag = baseFilename + resolutions[i].suffix;
                      sourceEl.setAttribute('srcset', filenameFrag + '.' + filetype + ', ' + filenameFrag + '@2x.' + filetype + ' 2x, ' + filenameFrag + '@3x.' + filetype + ' 3x');
                      element.appendChild(sourceEl);
                    }

                    // build img node
                    var imgEl = document.createElement('img');
                    imgEl.setAttribute('srcset', baseFilename + '-l-d.' + filetype);
                    imgEl.className = 'lazyloaded';
                    element.appendChild(imgEl);

                    // all other nodes - change text content
                  } else {
                    element.textContent = value;
                  }

                  // remove any contentful reference from element
                  element.removeAttribute('data-content');
                }
              }

              // reparse document to remove contentful references from bindings
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            this.presenter.scanDOM();
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    // remove class that sets all campaign content to not visible
    document.body.classList.remove('campaign-page');
  };

  this.scanNodeForClickAnalytics = function (rootNode) {
    if (!rootNode) rootNode = document;
    var nodes = $(rootNode).find('[data-analytics-id]');
    if (nodes.length > 0) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.tagName.toUpperCase() !== 'FORM') {
          $(node).off('click.analytics');
          $(node).on('click.analytics', this._onClickAnalyticsIdNode.bind(this));
        }
      }
    }
  };

  this._onClickAnalyticsIdNode = function (evt) {
    var label = $(evt.currentTarget).attr('data-analytics-id');
    if (label) {
      this.analytics.forcePushEvent('generic-member-navigation', {
        memberNavigation: [label]
      });
    }
  };

  this._onPageContentReady = function () {
    window.marketingApiPresenter.pageContentLoadedPromise.resolve();
    this.presenter.scanDOM();
    this.scanNodeForClickAnalytics();
  };
}